<template>
    <section class="author-profile-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-12" v-if="media >= 992">

                    <aside class="sidebar sidebar_author">
                        <profile-filter :media="media" :filters="filter" />

                        <profile-tabs :organization="organization"/>

                    </aside>

                </div>
                <div class="col-lg-8 col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <organization-about :stats="getterOrganizationStats" />
                        </div>
                    </div>

                    <div class="row" v-if="organization && organization.description">
                        <div class="col-md-12">
                            <organization-description :organization="organization"/>
                        </div>
                    </div>

                    <div class="row" v-if="media < 992">
                        <div class="col-md-12">
                            <profile-filter :media="media"  :filters="filter"/>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <projects :filter="profilePageList" :organization="organization" />
                        </div>
                    </div>

                    <div class="row" v-if="media < 992">
                        <div class="col-md-12">
                            <profile-tabs :organization="organization"/>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </section>
</template>

<script>
import {mapGetters} from 'vuex'

import ProfileTabs from "./OrganizationProfileTabs";
import OrganizationAbout from "./OrganizationAbout";
import OrganizationDescription from "./OrganizationDescription";
import Projects from "./OrganizationProjects";
import ProfileFilter from "../Profile/ProfileFilter";

export default {
    name: "OrganizationProfile",
    components: {
        ProfileTabs,
        OrganizationAbout,
        OrganizationDescription,
        ProfileFilter,
        Projects,
    },
    props: ['organization'],
    created() {
        this.myEventHandler()

        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed(){
        window.removeEventListener("resize", this.myEventHandler);
    },


    data(){
        return{
            media: null,
            filter: {
                params: [
                    {
                        nameValue: 'actualProjects',
                        title: this.$store.getters.t('organizations_profile_actual_projects'),
                        checked: true
                    },
                    {
                        nameValue: 'archivedProjects',
                        title: this.$store.getters.t('organizations_profile_archived_projects'),
                        checked: false
                    },
                    {
                        nameValue: 'membersPetsSelf',
                        title: this.$store.getters.t('organizations_profile_members_pets'),
                        checked: false
                    },
                    {
                        nameValue: 'membersPets',
                        title: this.$store.getters.t('organizations_profile_members_help'),
                        checked: false
                    }
                ],
                value: 'actualProjects'
            },
            stats: null
        }
    },


    mounted() {},
    computed: {

        ...mapGetters(['getterOrganizationStats']),

        profilePageList(){

            let result = {
                title: '',
                petsType: '',
            }

            switch (this.filter.value){
                case "actualProjects":
                    result.petsType = 'actualProjects';
                    result.title = this.$store.getters.t('organizations_profile_actual_projects');
                    break;
                case "archivedProjects":
                    result.petsType = 'archivedProjects';
                    result.title = this.$store.getters.t('organizations_profile_archived_projects');
                    break;
                case "membersPetsSelf":
                    result.petsType = 'membersPetsSelf';
                    result.title = this.$store.getters.t('organizations_profile_members_pets');
                    break;
                case "membersPets":
                    result.petsType = 'membersPets';
                    result.title = this.$store.getters.t('organizations_profile_members_help');
                    break;
                default:
                    result.petsType = 'actualProjects';
                    result.title = this.$store.getters.t('organizations_profile_actual_projects');
            }

            return result

        },
    },
    methods:{

        myEventHandler(e){
            this.media = window.innerWidth
        },

    }

}
</script>

<style scoped>

</style>
